<Nav></Nav><router-view @updateLoading="uploadLoading"></router-view><Foot :isLoading="isLoading"></Foot>